import { StyleSheet } from "react-native";
import { AppTheme } from "../../theme";

export const manualDiscountStyle = (theme: AppTheme) => StyleSheet.create({
    container: {
        flex: 1
    },

    // manual Discount List Styles
    label: {
        color: theme?.labelColor,
        fontSize: theme?.smallFontSize,
    },
    iconStyle: {
        padding: 10,
        backgroundColor: theme.lightBackgroundColor,
        borderRadius: 10,
        marginLeft: 10,
    },
    //Add/edit manual discount style
    subHeading: {
        fontSize: theme.largerFontSize,
        fontFamily: theme?.bold,
        color: theme?.primary,
        marginVertical: 10
    },
    buttonView: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        gap: 10,
        margin: 10

    },
    labelStyle: {
        fontSize: theme.smallerFontSize,
        color: theme.labelColor
    },
    inputStyle: {
        fontSize: theme?.tinyFontSize,
        color: theme?.dark,
        fontFamily: theme?.medium
    },
    checkBoxText: {
        color: theme.lightDark,
        fontSize: theme.smallFontSize,
        fontFamily: theme.medium
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: theme.primary,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    deleteIconView2: {
        alignSelf: "flex-end",
        backgroundColor: theme.red,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
})